export default [
    {
        path: "/despidos/decretos-de-ley",
        name: "despidos-decretos-de-ley",
        component: () =>
            import(/* webpackChunkName: "decretosDeLey" */ "./views/decretosDeLey.vue"),
    },
    {
        path: "/despidos/decretos-de-ley/crear",
        name: "despidos-decretos-de-ley-crear",
        component: () =>
            import(/* webpackChunkName: "agregarDecretoDeLey" */ "./views/formularioDecretoDeLey.vue"),
    },
    {
        path: "/despidos/decretos-de-ley/editar/:id",
        name: "despidos-decretos-de-ley-editar",
        component: () =>
            import(/* webpackChunkName: "agregarDecretoDeLey" */ "./views/formularioDecretoDeLey.vue"),
    },
    {
        path: "/despidos/decretos-de-ley/ver/:id",
        name: "despidos-decretos-de-ley-ver",
        meta: {modoVer: true},
        component: () =>
            import(/* webpackChunkName: "agregarDecretoDeLey" */ "./views/formularioDecretoDeLey.vue"),
    },
    {
        path: "/solicitudes-despidos",
        name: "solicitudes-despidos",
        component: () =>
            import(/* webpackChunkName: "solicitudesDespidos" */ "./views/solicitudesDespidos.vue"),
    },
    {
        path: "/despidos/sancionado/:id",
        name: "sancionado-visualizar",
        component: () =>
            import(/* webpackChunkName: "sancionadoVisualizar" */ "./views/despidoSancionadoVisualizar.vue"),
    },
    {
        path: "/despidos/sancionado/:id/historial/:historialId",
        name: "despido-sancionado-historial",
        component: () =>
            import(/* webpackChunkName: "despidoSancionadoHistorial" */ "./views/despidoSancionadoHistorial.vue"),
    },
    {
        path: "/solicitudes-despidos/simple/:id",
        name: "solicitudes-despidos-despido-simple-detalle",
        component: () =>
            import(/* webpackChunkName: "solicitudes-despidos-simple" */ "./views/despidos-simple-detalle.vue"),
    },
    {
        path: "/solicitudes-despidos/:id",
        name: "solicitudes-despidos-detalle",
        component: () =>
            import(/* webpackChunkName: "solicitudes-despidos-detalle" */ "./views/listadosEmpleadosDetalles.vue"),
    },
    {
        path: "/solicitudes-despidos/indemnizados/:id",
        name: "solicitudes-despidos-indemnizados-detalle",
        params: true,
        component: () => import (/* webpackChunkName: "solicitudes-despidos-indemnizados-detalle" */ "./views/despidoIndemnizadoDetalle.vue"),
    },
    {
        path: "/solicitudes-despidos/acuerdo/detalle",
        name: "solicitudes-despidos-acuerdo-detalle",
        component: () => import(/* webpackChunkName: "solicitudes-despidos-acuerdo-detalle" */ "./views/acuerdoDetalle.vue"),
    },
    {
        path: "/solicitudes-despidos/sanciones/:id",
        name: "solicitudes-despidos-sanciones-detalle",
        component: () =>
            import(
                /* webpackChunkName: "solicitudes-despidos-sanciones-detalle" */
                "./views/SancionDetalle.vue"
                ),
    },
    {
        path: "/detallepruevaComponente",
        name: "detallepruevaComponente",
        component: () =>
            import(
                /* webpackChunkName: "detallepruevaComponente" */
                "./views/detallepruevaComponente.vue"
                ),
    },
    {
        path: "/solicitudes-despidos/nueva/:id",
        name: "solicitudes-despidos-nueva",
        component: () =>
            import(
                /* webpackChunkName: "nuevaSolicitudDespido" */
                "./views/nuevaSolicitudDespido.vue"
                ),
    },
    {
        path: "/solicitudes-despidos/ufi/:id",
        name: "solicitudes-despidos-detalle-ufi",
        component: () =>
            import(/* webpackChunkName: "solicitudes-despidos-detalle" */ "./views/listadoEmpleadosUFI.vue"),
    },
    {
        path: "/despidos/sancion-detalle-v2/:id_empleado_puesto/:id_sancion",
        name: "despidosSancionDetalleV2",
        component: () => import("@/views/despidosV2/views/SancionDetalleDespidos.vue"),
        props: true,
    },
    {
        path: "/despidos/solicitudes/:id/detalle-juridico",
        name: "detalleSolicitudJuridico",
        component: () => import("./views/DetalleSolicitudJuridico.vue"),
        props: true,
    },
    {
        path: "/despidos/ufi/:id",
        name: "listadoDetalleUFI",
        component: () => import("./views/ListadoDetalleUFI.vue"),
        props: true,
    },
    {
        path: "/solicitudes-despidos/listado-empleados/:id",
        name: "solicitudes-despidos-listado-empleados",
        component: () => import("./views/listadosEmpleadosDespedir.vue"),
        props: true,
    },
 {
  path: "/despidos/jefe-unidad/detalle/:id",
  name: "solicitudes-despidos-jefe-unidad-detalle",
  component: () => import("./views/listaDetalleJefeUnidad.vue"),
  props: true,
},
    {
    path: "/despidos/titular/detalle/:id",
    name: "solicitudes-despidos-titular-detalle",
    component: () => import("./views/listaDetalleTitular.vue"),
    }
]